// extracted by mini-css-extract-plugin
module.exports = {"wizardPagesContainer":"wizard-step-indicator_wizardPagesContainer__2-m6i","actual":"wizard-step-indicator_actual__2BzA8","other":"wizard-step-indicator_other__1TXEl"};